import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="role-permissions"
export default class extends Controller {
  static targets = ['checkbox'];

  connect() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.addEventListener('change', this.handleCheckboxChange);
    });
  }

  disconnect() {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.removeEventListener('change', this.handleCheckboxChange);
    });
  }

  handleCheckboxChange = (event) => {
    const checkbox = event.target;
    const listItem = checkbox.closest('.role-item');
    const deleteField = listItem.querySelector('.delete-field');

    if (!checkbox.checked) {
      deleteField.value = true;
    } else {
      deleteField.value = false;
    }
  };
}
